import { mapState } from 'vuex';
import { messageDetail } from '@/api/notice.js';
import messageDetailModel from '@/layouts/components/message/messageDetailModel.vue';
let that;
export default {
  data() {
    return {
      messageDetailData: {}
    };
  },
  computed: {
    ...mapState({
      messageCenterList: state => state.message.messageCenterList,
      messageCenterTab: state => state.message.messageCenterTab,
      unReadCount: state => state.message.unReadCount,
      pagination: state => state.message.pagination
    })
  },
  filters: {
    formatContent(content) {
      if (content.indexOf('${reviewFlowView}') > -1) {
        let text = that.$t('查看');
        content = content.replace('${reviewFlowView}', text);
      }
      if (content.indexOf('${policyDetail}') > -1) {
        let text = that.$t('查看');
        content = content.replace('${policyDetail}', text);
      }
      if (content.indexOf('${taskList}') > -1) {
        let text = that.$t('查看');
        content = content.replace('${taskList}', text);
      }
      if (content.indexOf('${reviewFlowOperate}') > -1) {
        let text = that.$t('操作');
        content = content.replace('${reviewFlowOperate}', text);
      }
      return content;
    }
  },
  components: {
    messageDetailModel
  },
  created() {
    that = this;
    let tabKey = this.$route.params.tabKey || 'all';
    this.$store.commit('message/changeMessageCenterTab', tabKey);
    this.$store.commit('message/SET_CURRENT_PAGE', 1);
    this.$store.commit('message/SET_PAGE_SIZE', 10);
    this.$store.dispatch('message/getMessageCenterList');
    this.$store.dispatch('message/getUnReadCount');
  },
  methods: {
    onPageChange(page, pagesize) {
      this.$store.commit('message/SET_CURRENT_PAGE', page);
      this.$store.commit('message/SET_PAGE_SIZE', pagesize);
      this.$store.dispatch('message/getMessageCenterList');
    },
    onShowSizeChange(current, pageSize) {
      this.$store.commit('message/SET_CURRENT_PAGE', current);
      this.$store.commit('message/SET_PAGE_SIZE', pageSize);
      this.$store.dispatch('message/getMessageCenterList');
    },
    changeTab(tabKey) {
      this.$store.commit('message/changeMessageCenterTab', tabKey);
      this.$store.commit('message/SET_CURRENT_PAGE', 1);
      this.$store.commit('message/SET_PAGE_SIZE', 10);
      this.$store.dispatch('message/getMessageCenterList');
    },
    allRead() {
      this.$store.dispatch('message/readAll');
    },
    toDetail(item) {
      this.isLoading = true;
      messageDetail({
        messageDetailId: item.id
      }).then(res => {
        this.messageDetailData = res;
        this.$store.dispatch('message/getUnReadCount');
        this.$store.commit('message/readMessage', item.id);
      });
    }
  }
};